import * as api from '../api/WorkspaceAiSettings.api';

// Constants
import WorkspaceAiSettingsConstants from 'Shared/constants/WorkspaceAiSettings.constants';

// utils
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

// Schema
import WorkspaceAiSettingSchema from 'Shared/utils/normalizeJSON/schemas/WorkspaceAiSetting.schema';

export const createWorkspaceAiSettingSuccess = payload => ({
  type: WorkspaceAiSettingsConstants.Actions.CREATE_WORKSPACE_AI_SETTING_SUCCESS,
  payload,
});

export const updateWorkspaceAiSettingSuccess = payload => ({
  type: WorkspaceAiSettingsConstants.Actions.UPDATE_WORKSPACE_AI_SETTING_SUCCESS,
  payload,
});

export const createWorkspaceAiSetting = ({ workspaceId, data }) => dispatch => {
  return api.createWorkspaceAiSetting({ workspaceId, data }).then(response => {
    const responseData = normalizer(WorkspaceAiSettingSchema, response.data.workspace_ai_setting);
    dispatch(createWorkspaceAiSettingSuccess({ workspaceId, ...responseData }));
    return response;
  });
};

export const updateWorkspaceAiSetting = ({ workspaceId, workspaceAiSettingSlug, data }) => dispatch => {
  return api.updateWorkspaceAiSetting({ workspaceId, workspaceAiSettingSlug, data }).then(response => {
    const responseData = normalizer(WorkspaceAiSettingSchema, response.data.workspace_ai_setting);
    dispatch(updateWorkspaceAiSettingSuccess({ workspaceId, ...responseData }));
    return response;
  });
};
